import { render, staticRenderFns } from "./DocumentsItem.vue?vue&type=template&id=1785e743&"
import script from "./DocumentsItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsItem.vue?vue&type=style&index=0&id=1785e743&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1785e743')) {
      api.createRecord('1785e743', component.options)
    } else {
      api.reload('1785e743', component.options)
    }
    module.hot.accept("./DocumentsItem.vue?vue&type=template&id=1785e743&", function () {
      api.rerender('1785e743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/DocumentsItem.vue"
export default component.exports